import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import CheckoutPage from './components/CheckoutPage';
import OrderStatusPage from './components/OrderStatusPage';
import { resolveRoute } from './config';
import './index.css';

const route = resolveRoute();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

function render() {
  switch (route.view) {
    case 'checkout':
      return <CheckoutPage slug={route.slug} token={route.token} />;
    case 'success':
      return <OrderStatusPage slug={route.slug} status="success" />;
    case 'cancel':
      return <OrderStatusPage slug={route.slug} status="cancel" />;
    default:
      return <App slug={route.slug} />;
  }
}

createRoot(container).render(<React.StrictMode>{render()}</React.StrictMode>);
